module.exports = __webpack_public_path__ + "img/bg13.c9b95f45.jpg";